import Vue from 'vue'
import VueRouter from 'vue-router'
// 导入活动ID获取工具函数
// import { getActivityIdFromRoute, getActivityId } from '@/utils/urlUtil.js';
// // 导入store以访问全局状态
// import store from '@/store/index.js';

Vue.use(VueRouter)

// 设置页面标题的函数
function setPageTitle() {
  // 首先尝试从路由或URL获取当前的活动ID
  //const currentUrlActivityId = route && route.query ? getActivityIdFromRoute(route) : getActivityId();
  
  // 获取store中的全局活动ID
  //const globalActivityId = store.getters.getActivityId;
  
  //console.log('currentUrlActivityId:', currentUrlActivityId, 'globalActivityId:', globalActivityId);
  
  // 如果从URL获取到了活动ID，更新store中的值
//   if (currentUrlActivityId) {
//     if (currentUrlActivityId !== globalActivityId) {
//       store.dispatch('updateActivityId', currentUrlActivityId);
//       console.log('Updated store activityId to:', currentUrlActivityId);
//     }
//   }
  
  // 优先使用store中的活动ID，如果没有则使用当前URL中的
//   const finalActivityId = globalActivityId || currentUrlActivityId;
  
  // 根据活动ID设置标题
//   if (finalActivityId) {
//     // 根据不同的活动ID设置对应的标题
//     const titleMap = {
//       8: '兑换专区',
//       9: '专属兑换页面',
//       10: '深圳市宝安中医院(集团)工会',
//       12: '广垦臻享消费帮扶兑换专区',
//       13: '东西优选消费帮扶兑换专区',
//       14: '广垦臻享消费帮扶兑换专区',
//       15: '广州市建筑科学研究院集团',
//       16: '布吉水司元旦过节物品',
//     };
    
//     if (titleMap[finalActivityId]) {
//       document.title = titleMap[finalActivityId];
//       console.log('Title updated to:', titleMap[finalActivityId]);
//     } else {
//       // 如果没有找到对应的标题，使用默认标题
//       document.title = '兑换专区';
//       console.log('No matching title found, using default title: 兑换专区');
//     }
//   } else {
    // 默认标题
    document.title = '兑换专区';
    console.log('Using default title: 兑换专区');
//   }
}

// 配置项目路由
const router = new VueRouter({
    mode:'history',	//不配置mode的情况下，默认就是hash模式
    routes: [{
            path: '/',
            redirect: '/home', // 重定向
            meta: {
                isShowTabbar: true,
                keepAlive: true, //此组件需要被缓存
                isBack:false, //用于判断上一个页面是哪个
            }
        },
        {
            path: '/home', //首页
            name: 'Home',
            component: () => import('@/views/home/Home'),
            meta: {
                isShowTabbar: true,
                keepAlive: true, //此组件需要被缓存
                isBack:false, //用于判断上一个页面是哪个
            }
        },
        
        {
            path: '/topic', //专题
            name: 'Topic',
            component: () => import('@/views/topic/Topic'),
            meta: {
                isShowTabbar: true
            }

        },
        {
            path: '/searchPopup', //搜索
            name: 'searchPopup',
            component: () => import('@/views/search/searchPopup'),
        },
        
        
        {
            path: '/category', //分类
            name: 'Category',
            component: () => import('@/views/category/Category'),
            meta: {
                isShowTabbar: true,
                keepAlive: true, //此组件需要被缓存
                isBack:false, //用于判断上一个页面是哪个
            }

        },
        {
            path: '/cart', //购物车
            name: 'Cart',
            component: () => import('@/views/cart/Cart'),
            meta: {
                isShowTabbar: true
            }
        },
        {
            path: '/orderList', //订单列表
            name: 'orderList',
            component: () => import('@/views/orderList/orderList'),
        },
        {
            path: '/submit-order', //订单详情
            name: 'submit-order',
            component: () => import('@/views/submit-order/submit-order'),
        },
        {
            path: '/delivery-address', //收货地址
            name: 'delivery-address',
            component: () => import('@/views/delivery-address/delivery-address'),
        },
        {
            path: '/user', //我的
            name: 'User',
            component: () => import('@/views/user/User'),
            meta: {
                isShowTabbar: true
            }

        },
        {
            path: '/productDetail', //产品详情
            name: 'ProductDetail',
            component: () => import('@/views/productdetail/ProductDetail')
        },
        {
            path: '/editAddress', //修改地址
            name: 'editAddress',
            component: () => import('@/views/editAddress/editAddress')
        },
        {
            path: '/login', //登陆页面
            name: 'login',
            component: () => import('@/views/login/login')
        },
        {
            path: '/mobilelogin', //登陆页面
            name: 'mobilelogin',
            component: () => import('@/views/mobilelogin/mobilelogin')
            //
        },
        {
            path: '/passwordlogin', //登陆页面
            name: 'passwordlogin',
            component: () => import('@/views/passwordlogin/passwordlogin')
        },
        {
            path: '/channel', // 产品分类页面（从首页类别点进去如 居家-餐厨-配件。。。 ）
            name: 'Channel',
            component: () => import('@/views/channel/Channel.vue')
        },
        {
            path: '/order-detail', //退款商品详细信息
            name: 'order-detail',
            component: () => import('@/views/order-detail/order-detail.vue')
        },
         {
            path: '/Zone832', //绿色有机页面
            name: 'Zone832',
            component: () => import('@/views/Zone832/Zone832.vue')
        },
        {
            path: '/brand', // 品牌
            name: 'brand',
            component: () => import('@/views/brand/Brand.vue')
        },
        {
            path: '/pay-result', // 支付结果
            name: 'pay-result',
            component: () => import('@/views/pay-result/pay-result.vue')
        },
        {
            path: '/logisticsInfo', // 支付结果
            name: 'logisticsInfo',
            component: () => import('@/views/logisticsInfo/logisticsInfo.vue')
        },
        {
            path: '/afterSales', // 退款或售后
            name: 'afterSales',
            component: () => import('@/views/afterSales/afterSales.vue')
        },
        {
            path: '/DetailsOfRefund', //退款商品详细信息
            name: 'DetailsOfRefund',
            component: () => import('@/views/DetailsOfRefund/DetailsOfRefund.vue')
        },
        {
            path: '/applyRefund', //退款页面
            name: 'applyRefund',
            component: () => import('@/views/applyRefund/applyRefund.vue')
        },
        {
            path: '/about', //退款页面
            name: 'about',
            component: () => import('@/views/about/about.vue')
        },
        {
            path: '/giftcard', //卡券兑换页面giftcard
            name: 'giftcard',
            component: () => import('@/views/giftcard/giftcard.vue')
        },
        {
            path: '/Customerservice', //客服页
            name: 'Customerservice',
            component: () => import('@/views/Customerservice/Customerservice.vue')
        },{
            path: '/writeReturnLogistics', //退货退款填快递页面pages/writeReturnLogistics/writeReturnLogistics
            name: 'writeReturnLogistics',
            component: () => import('@/views/writeReturnLogistics/writeReturnLogistics.vue')
        },
    ]
})

// 路由前置守卫
router.beforeEach((to, from, next) => {
    // 有token就表示已经登录
    // 想要进入购物车页面，必须有登录标识token
    // console.log('to:', to)
    // console.log('from:', from)
    let token = localStorage.getItem('token')
    if (to.path == '/cart') {
        // 此时必须要有token
        if (token) {
            next(); // next()去到to所对应的路由界面
        } else {
            Vue.prototype.$toast('请先登录');
            // 定时器
            setTimeout(() => {
                next("/mobilelogin"); // 强制去到mobilelogin页面
            }, 1000);
        }
    }else if (to.path == '/user') {
        // 此时必须要有token
        if (token) {
            next(); // next()去到to所对应的路由界面
        } else {
            Vue.prototype.$toast('请先登录');
            // 定时器
            setTimeout(() => {
                next("/mobilelogin"); // 强制去到mobilelogin页面
            }, 1000);
        }
    }else if (to.path == '/submit-order') {
        // 此时必须要有token
        if (token) {
            next(); // next()去到to所对应的路由界面
        } else {
            Vue.prototype.$toast('请先登录');
            // 定时器
            setTimeout(() => {
                next("/mobilelogin"); // 强制去到mobilelogin页面
            }, 1000);
        }
    } else {
        // 如果不是去往购物车的路由，则直接通过守卫，去到to所对应的路由界面
        console.log('from.name',from);
        if(from.name=='ProductDetail'){
            console.log('ProductDetail');
            to.meta.isBack=true;
            //判断是从哪个路由过来的，
            //如果是page2过来的，表明当前页面不需要刷新获取新数据，直接用之前缓存的数据即可
        }
        
        next();
        // next()
    }
    
})


// 该段代码不需要记，理解即可
// 在vue-router在3.1.0版本之后，push和replace方法会返回一个promise对象，如果跳转到相同的路由，就报promise uncaught异常
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch((err) => err);
};


// 路由变化时更新标题
router.afterEach((to) => {
  setPageTitle(to);
});

// 初始加载时设置标题
setPageTitle();

export default router